import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import {
  checkCurrencyFormatting,
  fieldRequired,
  requiredInput,
} from '../../../core/formValidation';

export const PurchaseOrderItemFields = ({ fields }) => {
  return (
    <div className="inline-add-item-button">
      {fields.map((item, index) => (
        <div key={index} className="field-row">
          <div className="field-row-heading">
            <label>Item {index + 1}</label>
            <button
              className={classNames('close', 'no-float', 'multi-form-delete')}
              onClick={() => {
                fields.remove(index);
              }}
            >
              <i className="icon icon-squared-cross" />
            </button>
          </div>
          <div>
            <div className="form-group form-small-row purchase-order-row">
              <span>
                <Field
                  className="form-control row-padding"
                  name={`${item}.name`}
                  id="name"
                  component={requiredInput}
                  type="text"
                  aria-describedby="descriptionHelp"
                  placeholder="Item name"
                  validate={[fieldRequired]}
                />
              </span>
              <span>
                <Field
                  className="form-control row-padding"
                  name={`${item}.quantity`}
                  id="quantity"
                  component={requiredInput}
                  type="number"
                  aria-describedby="descriptionHelp"
                  placeholder="Qty"
                  min="0"
                  validate={[fieldRequired]}
                  style={{ width: '60px' }}
                />
              </span>
              <span>
                <Field
                  className="form-control row-padding"
                  name={`${item}.price`}
                  id="price"
                  component={requiredInput}
                  type="text"
                  commas="true"
                  decimal="2"
                  aria-describedby="descriptionHelp"
                  placeholder="Amount ($0.00)"
                  validate={[checkCurrencyFormatting]}
                  style={{ width: '140px' }}
                />
              </span>
            </div>
          </div>
        </div>
      ))}
      <button
        className={classNames('button', 'full-width')}
        onClick={() => {
          fields.push();
        }}
      >
        Add Item
      </button>
    </div>
  );
};

PurchaseOrderItemFields.propTypes = {
  fields: PropTypes.shape({}),
};

export default PurchaseOrderItemFields;
